export default __webpack_public_path__ + "static/media/property.8058b74f.svg";